// extracted by mini-css-extract-plugin
export var askAiIcon = "_m5-9";
export var container = "_m5-0";
export var groupSeparator = "_m5-a";
export var highlight = "_m5-4";
export var resultIcon = "_m5-5";
export var resultItem = "_m5-7";
export var resultSubtitle = "_m5-3";
export var resultTitle = "_m5-2";
export var resultsList = "_m5-1";
export var searchGroup = "_m5-6";
export var selected = "_m5-8";